import { type UncheckedQueryState } from './hooks/usePromiseToQuery';
import type { QueryState, MutationQueryState } from './queryState';

export const unwrapQuery = <T>(
  queryState: QueryState<T> | MutationQueryState<T> | UncheckedQueryState<T>,
) => (queryState.status === 'success' ? queryState.data : undefined);
